import Grid from '@mui/material/Grid';
import type {
  ContentObjectAction,
  ContentObjectOption,
  ContentObjectProps,
} from '@openx/types/targeting/contentObject';
import type { UseOptionFetch } from '@openx/types/targeting/targeting';
import { OptionsDropdown } from '../../../shared/OptionsDropdown/OptionsDropdown';
import { getOptionName, inputPlaceholder } from '../../constants';

export const StandardDropdown = (props: {
  type: ContentObjectOption;
  formState: Pick<ContentObjectProps, 'contentrating' | 'language'>;
  useOptionFetch: UseOptionFetch;
  dispatch: (action: ContentObjectAction) => void;
}) => {
  const { useOptionFetch, dispatch, formState, type } = props;
  const { loading, options } = useOptionFetch(type);

  const selectedOptions = formState[type]?.val || new Set<string>();

  return (
    <Grid size={9}>
      <OptionsDropdown
        loading={loading}
        options={options}
        onChange={ids => {
          dispatch({ type, values: ids });
        }}
        selectedOptions={selectedOptions}
        label={getOptionName(type)}
        placeholder={inputPlaceholder(type)}
        dataTest="content-object-input"
      />
    </Grid>
  );
};
